/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod';

export const QPChatCandidateColumnSchema = z.object({
  createdAt: z.string().datetime().nullish(),
  disabledColumns: z.array(z.string()),
  enabledColumns: z.array(z.string()),
  id: z.string().uuid(),
  updatedAt: z.string().datetime().nullish(),
  userId: z.string().uuid(),
});

export type QPChatCandidateColumn = z.infer<typeof QPChatCandidateColumnSchema>;
